export const MIN_FAKE_SCROLL = -5;
export const MAX_FAKE_SCROLL = 5;
export const NEXT = 'next';
export const PREV = 'prev';
export const LANDING = 'landing';
export const INTRO = 'intro';
export const HABITAT1 = 'habitat1';
export const HABITAT2 = 'habitat2';
export const HABITAT3 = 'habitat3';
export const PLEDGE = 'pledge';
export const NUM_HABITATS = 3;
export const FROG = 'frog';
export const TURTLE = 'turtle';
export const BUTTERFLY = 'butterfly';
export const FOREST = 'forest';
export const OCEAN = 'ocean';
export const GRASSLAND = 'grassland';
export const NUM_GLOBE_LOAD_FRAMES = 95;
export const HABITAT = 'habitat';

